import getRequestUrl from "./getRequestUrl";
import getRequestAndHeaders from "./getRequestAndHeaders";

export default async () => {
  const { request, headers } = await getRequestAndHeaders();
  const requestUrl = getRequestUrl();

  try {
    const { data } = await request.get({
      url: requestUrl,
      headers
    });

    return data;
    // eslint-disable-next-line no-empty
  } catch (e) {}

  return null;
};
